import "./Main.css";
import "../CurrentProjects/CurrentProjects.css";
import React from "react";
import AboutUs from "./AboutUs";
import OurTeam from "./OurTeam";
import Partners from "./Partners";
import Help from "./Help";
import CurrentProjects from "../CurrentProjects/CurrentProjects";

export default function Main() {
  return (
    <main className="skyua-home-main">
      <AboutUs />
      <OurTeam />
      <Help />

      <section className="skyua-main-section skyua-main-section--soft skyua-current-projects-section">
        <div className="skyua-main-container">
          <CurrentProjects />
        </div>
      </section>

      <Partners />
    </main>
  );
}
